export default "__VITE_ASSET__Y0ovFWjN__"